import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./motion";

export default function BrokerQuote() {
  return (
    <section data-testid="broker-quote" className="bg-[#FAF9F6] py-24 md:py-32 border-t border-[#0A1128]/8">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <Reveal>
          <Eyebrow>Broker&apos;s Endorsement</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <Quote size={42} className="text-[var(--gold)] mx-auto mt-8 mb-4" strokeWidth={1.2} />
        </Reveal>
        <Reveal delay={0.15}>
          <blockquote className="font-serif italic text-2xl md:text-4xl leading-snug text-[#0A1128] text-balance">
            &ldquo;Mabel&apos;s knowledge, dedication and enthusiasm are infectious, which undoubtedly makes her an excellent Sales Associate. Having worked behind the scenes for so many years, she brings with her an innate and truly valuable insight to real estate sales.&rdquo;
          </blockquote>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex items-center justify-center gap-6">
            <div className="h-px w-14 bg-[var(--gold)]" />
            <div className="text-left">
              <div className="text-sm font-medium text-[#0A1128]">Kim Lund</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-[var(--slate)]">Broker / Owner · RE/MAX Cayman Islands</div>
            </div>
            <div className="h-px w-14 bg-[var(--gold)]" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
